import React from 'react';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink'; 
import { wrapTrademarkSuperscript } from '../../../utils/cob-utils';
import { IconChevronUp } from '../../../importCL';

const ToggleDropdownButton = ({ isOpen, setIsOpen, linkLabel }) => {
    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    return <button
        aria-label={isOpen ? 'Close dropdown' : 'Open dropdown'}
        className={`SearchRibbon__dropdownBtn ${isOpen ? '' : 'SearchRibbon__dropdownBtn--closed'}`}
        type='button'
        onClick={toggleDropdown}
    >
        {transformHTMLParserLinks(wrapTrademarkSuperscript(linkLabel))} <IconChevronUp size={16} />
    </button>;
};

export default ToggleDropdownButton;